module.exports = __webpack_public_path__ + "img/15.ef2f3679.jpg";